import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: grid;
  grid-template-columns: auto auto;
  background-color: ${({ theme }) => theme.colors.neutral.white};
  border-radius: 24px 24px 0px 0px;
  padding: 16px;

  ${media.greaterThan("1200px")`
    background-color: transparent;
    padding: 0 12px;
  `}
`;

export const Routes = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  color: ${({ theme }) => theme.colors.neutral.black};
  ${({ theme }) => theme.font.heading.xs};
  font-weight: ${({ theme }) => theme.font.weight.regular};

  svg {
    cursor: pointer;
  }
`;

export const Parent = styled.p`
  margin: 0px 4px;
  cursor: pointer;
  ${({ theme }) => theme.font.heading.xs};
  font-weight: ${({ theme }) => theme.font.weight.regular};

  &:hover {
    text-decoration: underline;
  }
`;

export const Highlight = styled.p`
  margin-left: 4px;
  font-weight: ${({ theme }) => theme.font.weight.bold};
  ${({ theme }) => theme.font.heading.xs};
  color: ${({ theme }) => theme.colors.primary.vividCerulean};
`;

export const ExternalWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.neutral.white};
  padding: 16px;
  box-shadow: 0px -8px 16px 0px
    ${({ theme }) => theme.colors.primary.cetaceanBlue}20;

  button {
    width: 100%;
  }

  ${media.greaterThan("1200px")`
    box-shadow: none;
    padding: 0;
    position: relative;
    width: 100%;
    background-color: transparent;
    padding: 0;

    button {
      width: auto;
    }
  `}
`;
